/**
 * Режим приложения: реальный счёт или демо (доработки §3).
 *
 * Почему `localStorage`, а не `sessionStorage`, которым живёт фильтр каталога:
 * фильтр — настройка просмотра, а режим — то, в каком продукте человек
 * находится. Выйти из демо, просто закрыв мини-апп, и обнаружить себя на
 * реальном счёте — ровно тот demo/real mix-up, от которого предостерегает §10.
 *
 * Доступ к storage обёрнут: в WebView с запрещёнными куками само обращение к
 * нему бросает, а приложение обязано открыться в любом случае — в реальном
 * режиме, потому что он безопаснее как значение по умолчанию.
 */
export type AppMode = "real" | "demo";

export const DEFAULT_MODE: AppMode = "real";

const KEY = "app:mode";
const ALLOWED: readonly AppMode[] = ["real", "demo"];

export function readMode(): AppMode {
  try {
    const stored = localStorage.getItem(KEY);
    return ALLOWED.find((value) => value === stored) ?? DEFAULT_MODE;
  } catch {
    return DEFAULT_MODE;
  }
}

export function writeMode(value: AppMode): void {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // Режим не переживёт перезапуск — приложение от этого не ломается.
  }
}
